/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportActivityV2MutationRequest,
  ExportActivityV2MutationResponse,
  ExportActivityV2400,
  ExportActivityV2500,
} from '../types/ExportActivityV2'

function getExportActivityV2Url() {
  const res = {
    method: 'POST',
    url: `/api/v1/activity/v2/team/export/v3/` as const,
  }
  return res
}

/**
 * @description Start an async activity export.
 * @summary Start an async team activity export
 * {@link /api/v1/activity/v2/team/export/v3/}
 */
export async function exportActivityV2(
  data: ExportActivityV2MutationRequest,
  config: Partial<RequestConfig<ExportActivityV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportActivityV2MutationResponse,
    ResponseErrorConfig<ExportActivityV2400 | ExportActivityV2500>,
    ExportActivityV2MutationRequest
  >({
    method: 'POST',
    url: getExportActivityV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
